module.exports = __webpack_public_path__ + "static/img/go-home.30225a98.png";